export default __webpack_public_path__ + "static/media/LOGO_GIP_55.23389118.jpg";